export const PRIVACY_POLICY_STANDARD_CONTROLLED_REGISTER =
  "https://www.evaluar.com/politica-de-privacidad";
export const PRIVACY_POLICIES =
  "https://www.evaluar.com/politica-de-proteccion-de-datos-evaluar-v1";
